module.exports = __webpack_public_path__ + "img/reserve.2fe00d51.png";